@import '../../style/layout/index';
@import '~bulma/sass/elements/container';

/* This class is being extended from the ".container" class from bulma */
/* stylelint-disable-next-line selector-class-pattern */
.container {
  box-sizing: border-box; // Bulma relies on inherited styles for this rule.
  display: block;
  max-width: $max-width-container-small;

  /**
   * We need to make sure we override all bulma container selectors.
   * They all have higher specificity than our own, hence the !important.
   */
  /* stylelint-disable declaration-no-important */
  @include medium-up() {
    max-width: $max-width-container-medium !important;
  }

  @include large-up() {
    max-width: $max-width-container-large !important;
  }

  @include xlarge-up() {
    max-width: $max-width-container-xlarge !important;
  }

  @include xxlarge-up() {
    max-width: $max-width-container-xxlarge !important;
  }
  /* stylelint-enable declaration-no-important */

  &--full-width {
    // stylelint-disable-next-line declaration-no-important
    max-width: none !important;
  }

  &--full-width-mobile {
    // stylelint-disable-next-line declaration-no-important
    max-width: none !important;
    /* stylelint-disable declaration-no-important */
    @include medium-up() {
      max-width: $max-width-container-medium !important;
    }

    @include large-up() {
      max-width: $max-width-container-large !important;
    }

    @include xlarge-up() {
      max-width: $max-width-container-xlarge !important;
    }

    @include xxlarge-up() {
      max-width: $max-width-container-xxlarge !important;
    }
  }
}
